import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-uw-reshuffle-dialog',
  templateUrl: './uw-reshuffle-dialog.component.html',
  styleUrls: ['./uw-reshuffle-dialog.component.css']
})
export class UwReshuffleDialogComponent implements OnInit {

    public message: string = "";
    public loanlist = [];
    public assignedLoanList = [];
    public loanlistSsnMismatch = [];

    constructor(public dialogRef: MatDialogRef<UwReshuffleDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any) { }

    ngOnInit() {
        this.message = this.data[0].message;
        if (this.data[0].LoanList != null && this.data[0].LoanList.length > 0) {
            this.loanlist = this.data[0].LoanList;
        }
        else {
            this.loanlist = null;
        }
        if (this.data[0].AssignedLoanList != null && this.data[0].AssignedLoanList.length > 0) {
            this.assignedLoanList = this.data[0].AssignedLoanList;
        }
        else {
            this.assignedLoanList = null;
        }

        if (this.data[0].loanlistSsnMismatch != null && this.data[0].loanlistSsnMismatch.length > 0) {
            this.loanlistSsnMismatch = this.data[0].loanlistSsnMismatch;
        }
        else {
            this.loanlistSsnMismatch = null;
        }

    }

    DialogClose() {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/uw-reshuffle-dialog/uw-reshuffle-dialog.component.ts